import * as React from 'react';
import { Switch as NativeSwitch } from 'react-native';
import styled from 'styled-components/native';
import { useTheme } from '../../hooks';
import { Theme } from '../../theme';
import { Box } from '../Box';
import { Text } from '../Text';
import { Tooltip } from '../Tooltip';
import { TranslatableText, Translate, useTranslate } from '../Translate';

export interface ListSwitchProps {
  label: TranslatableText|React.ReactNode;
  onChange: (newValue: boolean) => void;
  value: boolean;
  tooltip?: {
    title: TranslatableText;
    text: TranslatableText;
    youtubeId?: string;
  };
}

const ListSwitchView = styled.TouchableOpacity`
  padding: ${(props) => props.theme.spacing.md};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  border-bottom-color: ${(props: { theme: Theme }) => props.theme.palette.lineColor};
  border-bottom-width: 1px;
  flex: 0 1 auto;
  min-height: 50px;
`;

export const ListSwitch = (props: ListSwitchProps) => {  
  const translate = useTranslate();
  const label = typeof props.label === "string" ? translate(props.label) : undefined;

  return (
    <ListSwitchView
      accessibilityRole="switch"
      accessibilityLabel={label}
      accessibilityState={{ checked: props.value }}
      aria-checked={props.value}
      activeOpacity={0.8}
      onPress={() => props.onChange(!props.value)}
    >
      <NativeSwitch 
        value={props.value}
        pointerEvents="none"
        accessibilityElementsHidden={true}
        importantForAccessibility="no-hide-descendants"
        // thumbColor={"blue"}
        // activeThumbColor={"purple"}
        // trackColor={}
      />
      <Box marginLeft="md" flexShrink={1}>
        <Text size="sm">{typeof props.label === "string" ? <Translate text={props.label} /> : props.label}</Text>
      </Box>
      {props.tooltip && (
        <Tooltip title={props.tooltip.title} text={props.tooltip.text} youtubeId={props.tooltip.youtubeId} />
      )}
    </ListSwitchView>
  )
}
